(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit.js');
'use strict';

const DepositComponent = svs.accountservicesReact.deposit.DepositComponent;
const DepositReduxProvider = svs.accountservicesReact.deposit.store.DepositReduxProvider;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const Deposit = _ref => {
  let instantPay = _ref.instantPay,
    hasNoProfileLinkSwish = _ref.hasNoProfileLinkSwish,
    isHideDepositLimits = _ref.isHideDepositLimits,
    _ref$isPlayerRegistra = _ref.isPlayerRegistration,
    isPlayerRegistration = _ref$isPlayerRegistra === void 0 ? false : _ref$isPlayerRegistra,
    swedbankPayProps = _ref.swedbankPayProps;
  return React.createElement(ErrorBoundary, null, React.createElement(DepositReduxProvider, null, React.createElement(DepositComponent, {
    hasNoProfileLinkSwish: hasNoProfileLinkSwish,
    instantPay: instantPay,
    isHideDepositLimits: isHideDepositLimits,
    isPlayerRegistration: isPlayerRegistration,
    swedbankPayProps: swedbankPayProps
  })));
};
svs.accountservicesReact.deposit.Deposit = Deposit;

 })(window);